import { render, staticRenderFns } from "./SolicitacaoDeOrcamentoView.vue?vue&type=template&id=03629a8c&scoped=true"
import script from "./SolicitacaoDeOrcamentoView.vue?vue&type=script&lang=js"
export * from "./SolicitacaoDeOrcamentoView.vue?vue&type=script&lang=js"
import style0 from "./SolicitacaoDeOrcamentoView.vue?vue&type=style&index=0&id=03629a8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03629a8c",
  null
  
)

export default component.exports